import { createSelector } from 'reselect';

export const selectLoadedState = (state: { loaded: any }) => state.loaded;
export const selectLocations = (state: { locations: any }) => state.locations;
export const selectSyncError = (state: { error: any }) => state.error;
export const selectSyncState = (state: { syncing: any }) => state.syncing;

export const selectIndexedLocations = createSelector(selectLocations, (locations) =>
  locations.reduce((indexed: { [x: string]: any }, location: any) => {
    if (location.value) {
      indexed[location.value] = location;
    }
    return indexed;
  }, {})
);
export const selectLocation = createSelector(
  [selectIndexedLocations, (_: any, id: any) => id],
  (indexedLocations, id) => indexedLocations[id]
);
